/**
 * Maps subject abbreviations to sentence-friendly display names.
 * Use this when you need a subject rendered in the middle of a sentence.
 */
export const formatSubjectForSentence = (
  subject: string | number | boolean | undefined,
): string | undefined => {
  if (!subject) return undefined;

  const subjectString = String(subject)
    .toLowerCase()
    .trim();

  const subjectMap: Record<string, string> = {
    ela: 'English',
    math: 'math',
    science: 'science',
    social_studies: 'social studies',
    socialstudies: 'social studies',
    world_languages: 'world languages',
    worldlanguages: 'world languages',
    mental_health: 'mental health',
    mentalhealth: 'mental health',
    other: '',
  };

  return subjectMap[subjectString] || String(subject);
};
